import React from 'react';
import { Check, Mail, HelpCircle, ShieldCheck, Lock, Star, PlayCircle } from 'lucide-react';
const CTAButton = ({
  className = ''
}: {
  className?: string;
}) => <div data-id="element-3874" data-mp="1xgdp71y1bkuu">
    <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak-g" className={`block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-4 px-4 rounded-lg text-center transition-colors shadow-lg ${className}`} data-id="element-3875" data-mp="1xg49c76peu2v">
      <span className="block text-sm font-normal mb-1" data-id="element-3876" data-mp="2q49sipi40b0l">Ga naar stap #2</span>
      <span className="block text-xl" data-id="element-3877" data-mp="2l79nmhwzxeb2">Start de aanpak nu</span>
    </a>
    <img src="https://cdn.magicpatterns.com/uploads/4vdV4HP3iomaCgiRo35kk3/ORAweI9onQltdmefOLBalrxDMg.png" alt="Betaalmethoden: Mastercard, CB, Apple Pay, iDEAL, SEPA, Visa, PayPal, American Express, Klarna, Bancontact" className="mx-auto mt-3 h-10 w-auto max-w-[280px] opacity-80" data-id="element-3878" data-mp="2g6c52482qi91" />
  </div>;
const PricingCard = () => <div className="bg-white rounded-xl shadow-xl p-6 border-t-8 border-[#5ce0d2] text-center flex flex-col h-full" data-id="element-3879" data-mp="10otlpgrnr1dv">
    <h3 className="text-[#5ce0d2] font-extrabold text-2xl mb-1 uppercase tracking-wide" data-id="element-3880" data-mp="sgtbh3dexnh9">
      Nu nog beschikbaar
    </h3>
    <h2 className="text-4xl font-black text-[#1a2b4a] mb-6" data-id="element-3881" data-mp="jihjoy0t8jn8">Start vandaag</h2>

    <div className="mb-6" data-id="element-3882" data-mp="jkk7dbehq0os">
      <img src="https://cdn.magicpatterns.com/uploads/vxv92giZwb84avmwkmhTZx/Scherm­afbeelding_2026-04-12_om_21.51.15.png" alt="Verlatingsangst Kernaanpak - training op laptop, tablet en telefoon" className="w-full h-auto object-contain" data-id="element-3883" data-mp="nj9u3ulf4ul3" />
    </div>

    <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-3884" data-mp="3vzmjl0nf9k41">Nu voor €27</div>
    <div className="text-[#e53e3e] font-bold text-lg mb-6" data-id="element-3885" data-mp="3vxjj1mon88l2">(Bespaar €70)</div>

    <p className="text-sm text-gray-600 mb-6 leading-relaxed" data-id="element-3886" data-mp="4tutu2dk49hr">
      Start met de Verlatingsangst Kernaanpak voor €27 in plaats van{' '}
      <span className="line-through" data-id="element-3887" data-mp="3ry19to66ply2">€97</span>. Per direct toegang. Start
      binnen de 3 minuten.
    </p>

    <p className="text-[#22c55e] font-bold text-sm mb-6" data-id="element-3888" data-mp="1xhj14occ45ir">
      Nu beschikbaar voor directe toegang
    </p>

    <CTAButton className="mb-4" data-id="element-3889" data-mp="1sqkivj7scxcv" />

    <div className="text-xs text-gray-500 space-y-2 mt-auto pt-4" data-id="element-3890" data-mp="1sqasvvmqqq76">
      <p className="flex items-center justify-center gap-1" data-id="element-3891" data-mp="1nrhp4ux9adk7">
        <Lock className="w-4 h-4" data-id="element-3892" data-mp="1npwpwrzzy6g0" /> 100% veilig afrekenen
      </p>
      <p className="flex items-center justify-center gap-1" data-id="element-3893" data-mp="1jrp9jy9g375c">
        <ShieldCheck className="w-4 h-4" data-id="element-3894" data-mp="2gh6qxahsihmv" /> Met onze 100% geld terug garantie
      </p>
    </div>
  </div>;
export function VerlatingsangstPageG() {
  return <div className="min-h-screen bg-[#faf5eb] font-sans text-gray-800 pb-24 md:pb-0" data-id="element-3895" data-mp="2bidelle8owoa">
      {/* 1. HEADER */}
      <div className="bg-[#e6f7f5] py-3 px-4" data-id="element-3896" data-mp="27htfwde0pl01">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-3897" data-mp="22fuakxypwe0g">
          <div className="flex-1 hidden md:block" data-id="element-3898" data-mp="w1uxvk0v3omo"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-3899" data-mp="r1qjq0nff5zm" />
          <div className="flex-1 flex justify-center md:justify-end" data-id="element-3900" data-mp="37p8asvlejcpz">
            <a href="mailto:amee@stresslessdogs.nl" className="flex items-center text-sm font-bold text-[#1a2b4a] hover:text-[#5ce0d2] transition-colors" data-id="element-3901" data-mp="3bq0llt9x9pod">
              <Mail className="w-5 h-5 mr-2" data-id="element-3902" data-mp="3lftw0qybvyr1" />
              Hulp nodig? Email mij{' '}
              <span className="text-blue-600 ml-1 underline" data-id="element-3903" data-mp="3lhy0ba052zru">HIER.</span>
            </a>
          </div>
        </div>
      </div>

      {/* 2. BLACK BANNER */}
      <div className="bg-black text-white text-center py-4 px-4 font-bold text-sm md:text-base tracking-wide" data-id="element-3904" data-mp="3vf2jd0youf4f">
        Voor baasjes die hun hond willen bevrijden van zijn verlatingsangst (en
        zichzelf ook)
      </div>

      {/* 3. HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-16" data-id="element-3905" data-mp="25120w69ssde1">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#1a2b4a] text-center mb-6 leading-tight" data-id="element-3906" data-mp="253ehog3tkhpi">
          Oefenen is niet genoeg: Hoe je de echte oorzaak van verlatingsangst in
          3 stappen oplost
        </h1>
        <p className="text-lg md:text-2xl text-center text-gray-700 mb-12 max-w-4xl mx-auto font-medium leading-relaxed" data-id="element-3907" data-mp="1jpusln4kyj07">
          Zodat je hond zonder stress alleen thuis kan blijven, jij je vrijheid
          terugkrijgt, en je nooit meer bang hoeft te zijn dat je buren klagen.
        </p>

        <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-3908" data-mp="m1ugywtr44fb">
          <div className="md:col-span-8" data-id="element-3909" data-mp="lzhpnt23shpl">
            <div className="rounded-xl overflow-hidden shadow-2xl bg-black border-4 border-white" data-id="element-3910" data-mp="10qz14jk3wiq2">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-3911" data-mp="vz8na3lynctw">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Hero Video" data-id="element-3912" data-mp="87tcrnk15p7k"></iframe>
              </div>
            </div>
            <p className="text-center text-sm text-gray-500 mt-3 underline cursor-pointer" data-id="element-3913" data-mp="2xpzbgfb1zppw">
              Klik op afspelen om de video te starten
            </p>

            {/* Wat is de nieuwe Verlatingsangst Kernaanpak? - direct under video */}
            <div className="mt-8" data-id="element-3914" data-mp="2oqkj1abbt52r">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-4 text-center" data-id="element-3915" data-mp="2tmjh5pmgi1gd">
                Wat is de nieuwe Verlatingsangst Kernaanpak?
              </h2>
              <div className="text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-3916" data-mp="1dbfgc6b736j5">
                <p data-id="element-3917" data-mp="1i9gwaidbqpqe">
                  De Verlatingsangst Kernmethode is een stap voor stap aanpak
                  die hondenbaasjes helpt om de echte oorzaak van de spanning
                  van hun hond te herkennen, te begrijpen en blijvend op te
                  lossen.
                </p>
                <p data-id="element-3918" data-mp="3a5paj76eqau5">
                  We laten je precies zien waardoor de spanning bij jouw hond
                  ontstaat en hoe je op basis daarvan een gericht trainingsplan
                  maakt dat de verlatingsangst bij het onderliggende probleem
                  aanpakt.
                </p>
                <p className="font-bold text-[#1a2b4a]" data-id="element-3919" data-mp="2w9tvjcf4pjw1">
                  Zodat je dit niet tijdelijk, maar echt voorgoed oplost.
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4" data-id="element-3920" data-mp="2n95iajxk7nk7">
            <PricingCard data-id="element-3921" data-mp="phsz80l0st58" />
          </div>
        </div>
      </section>

      {/* 6. VOOR WIE WERKT DIT */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-3922" data-mp="lffy5ph7xjes">
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-3923" data-mp="ldv564ajy8j1">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-3924" data-mp="23b87gj87ilb5">
            Voor wie werkt dit
          </h3>
          <p className="mb-6 text-gray-700" data-id="element-3925" data-mp="2d346pxm14hgy">
            Voor alle baasjes die honden met verlatingsangst die in paniek raken
            als hun baasje ze thuis achter laat:
          </p>
          <ul className="space-y-4" data-id="element-3926" data-mp="2h6k1eoejg7r0">
            {['Het maakt niet uit als je nog nooit eerder met je hond hebt getraind.', 'De methode is eenvoudig en praktisch, zodat iedereen ermee aan de slag kan.', 'Geschikt voor honden van alle leeftijden en alle formaten.', 'Werkt ook bij speciale honden of honden met een rugzakje'].map((item, i) => <li key={i} className="flex items-start" data-id="element-3927" data-mp="34ubmohi23v4f" data-mpi={i}>
                <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-3928" data-mp="34ts4czohv4pv" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-3929" data-mp="39s3elbipbh8m">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* 7. MET DE METHODE */}
        <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-3930" data-mp="2gjb2xnmk434k">
          Met de Verlatingsangst Kernmethode…
        </h3>
        <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-3931" data-mp="2uazd3ld8whiw">
          <p data-id="element-3932" data-mp="2ph4vqol44emz">
            ...zal je het blaffen, piepen, huilen en slopen van je hond als jij
            vertrekt in drie stappen verminderen door het onderliggende probleem
            op te lossen dat er nu voor zorgt dat hij terugvalt.
          </p>
          <p data-id="element-3933" data-mp="3d8io2uj9ka7y">Waardoor hij niet zal terugvallen en het oefenen sneller gaat.</p>
          <p className="font-bold text-[#1a2b4a]" data-id="element-3934" data-mp="396f9vy57mriz">
            Geen gevoel dat je keihard samen oefent maar nergens komt.
          </p>
        </div>

        <div className="mb-12 rounded-xl overflow-hidden shadow-lg" data-id="element-3935" data-mp="1iur9rhpzp266">
          <img src="https://cdn.magicpatterns.com/uploads/vZLarCb4ynRSjgCisN7z8e/freepik_middelgrote-hond-in-een-g_2777443833.png" alt="Hond ontspannen op de bank terwijl baasje weggaat" className="w-full h-auto object-cover" data-id="element-3936" data-mp="1eswaeirmcyv1" />
        </div>

        {/* 8. SIGNALEN */}
        <div className="bg-[#e6f7f5] rounded-xl p-8 mb-12" data-id="element-3937" data-mp="uxl7iit2ke4q">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-3938" data-mp="zxqydwrilwlr">
            Signalen dat je hond verlatingsangst heeft
          </h3>
          <ul className="space-y-4" data-id="element-3939" data-mp="kzf39ujsivwp">
            {['Piept, blaft of krijgt spanning als jij wilt vertrekken', 'Stopt niet als je eenmaal van huis bent', 'In huis plassen of poepen terwijl hij zindelijk is', 'Slopen, krabben of bijten aan meubels of deuren', 'Andere signalen van spanning als je van huis weg gaat'].map((item, i) => <li key={i} className="flex items-start" data-id="element-3940" data-mp="26ecldi3nbflg" data-mpi={i}>
                <Check className="w-6 h-6 text-[#5ce0d2] mr-3 flex-shrink-0 mt-0.5" data-id="element-3941" data-mp="2bdfo2vw5l9q9" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-3942" data-mp="3a1lvivzskce2">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </section>

      {/* 9. FULL WIDTH PRICING CTA */}
      <section className="bg-white py-16 border-y border-gray-200" data-id="element-3943" data-mp="311ozuaezid9i">
        <div className="max-w-4xl mx-auto px-4" data-id="element-3944" data-mp="351zfkeskwi1k">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-3945" data-mp="352sdcq9k7x7k">
            <div data-id="element-3946" data-mp="3srlgp7sih7c7">
              <h2 className="text-3xl font-black text-[#1a2b4a] mb-4" data-id="element-3947" data-mp="3st4w6w6cfecx">
                Start vandaag
              </h2>
              <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-3948" data-mp="1kr0g2p8jwaj">
                Nu voor €27
              </div>
              <div className="text-[#e53e3e] font-bold text-lg mb-4" data-id="element-3949" data-mp="3jthx4h136kn1">
                (Bespaar €70)
              </div>
              <p className="text-gray-600 mb-6" data-id="element-3950" data-mp="28c9sbumj32ic">
                Start met de Verlatingsangst Kernaanpak voor €27 in plaats van{' '}
                <span className="line-through" data-id="element-3951" data-mp="2dbundtykuqps">€97</span>. Per direct toegang.
                Start binnen de 3 minuten.
              </p>
            </div>
            <div data-id="element-3952" data-mp="20sr0qzz7y0y5">
              <CTAButton data-id="element-3953" data-mp="20t8thmmo9x1b" />
              <div className="text-xs text-gray-500 space-y-2 mt-4 text-center" data-id="element-3954" data-mp="20rpfk2ohny2p">
                <p className="flex items-center justify-center gap-1" data-id="element-3955" data-mp="2er75wmhfnje6">
                  <Lock className="w-4 h-4" data-id="element-3956" data-mp="29tf4n1uwekxb" /> 100% veilig afrekenen
                </p>
                <p className="flex items-center justify-center gap-1" data-id="element-3957" data-mp="1m3ks6lehqydl">
                  <ShieldCheck className="w-4 h-4" data-id="element-3958" data-mp="1m3uhs7vmj3ir" /> Met onze 100% geld terug
                  garantie
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 10. DETAILED EXPLANATION + SIDEBAR */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-3959" data-mp="1r25wavwv627b">
        <div className="grid lg:grid-cols-12 gap-8" data-id="element-3960" data-mp="1r0l0z42q6f8e">
          {/* Left column - main content */}
          <div className="lg:col-span-8" data-id="element-3961" data-mp="13b0guhuu5bxj">
            <h2 className="text-3xl font-bold text-[#5ce0d2] mb-6" data-id="element-3962" data-mp="yes4tdbxpyul">
              Wat is de nieuwe Verlatingsangst Kernaanpak?
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-3963" data-mp="2yfzsg0celsgi">
              <p data-id="element-3964" data-mp="33drsjhn7ckvs">
                Oefenen heeft pas zin als je het onderliggende probleem eerst
                oplost.
              </p>
              <p data-id="element-3965" data-mp="3c7mz8u3z2jdj">
                Doe je dat niet, dan komt dat kernprobleem vroeg of laat weer
                naar boven. En dan leert je hond opnieuw dat er vervelende
                dingen gebeuren als hij alleen is.
              </p>
              <p data-id="element-3966" data-mp="2khi7gadvuu2a">
                Sommige onderliggende kernproblemen komen snel en vaak omhoog,
                waardoor je met oefenen niet verder komt dan een paar minuten.
              </p>
              <p data-id="element-3967" data-mp="2theyginqw50i">
                Andere kernproblemen zijn er minder vaak. Waardoor het na
                maanden oefenen lijkt te lukken om je hond 20 minuten alleen te
                laten, maar dan gebeurt er iets en ben je weer helemaal terug
                bij af.
              </p>
              <p className="font-medium" data-id="element-3968" data-mp="iv4eo2tpdzgp">
                Daarom moet je eerst het onderliggende probleem oplossen. Dit is
                hoe het werkt.
              </p>
            </div>

            {/* 11. 3 STEPS */}
            <div className="mb-8 rounded-xl overflow-hidden" data-id="element-3969" data-mp="93qj264vhjsu">
              <img src="https://cdn.magicpatterns.com/uploads/gZydPdwYJ47daE8nNYhLdq/9b6d1fe9789894c2655050948709230b.png" alt="Oude Aanpak vs De Nieuwe Verlatingsangst Kernaanpak" className="w-full h-auto object-contain rounded-lg" data-id="element-3970" data-mp="53py02n9qact" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-8 text-center" data-id="element-3971" data-mp="3matdwpfayc6h">
              Kernprobleem oplossen in drie stappen
            </h2>
            <div className="space-y-8 mb-16" data-id="element-3972" data-mp="3ic2q58wq86w1">
              {[{
              title: 'Stap 1: Diagnose',
              text: 'De eerste stap is begrijpen welke van de vijf onderliggende kernproblemen er bij jouw hond spelen. En hiervoor moet je een diagnose doen.'
            }, {
              title: 'Stap 2: Behandelplan',
              text: 'De tweede stap is om het kernprobleem dat de echte oorzaak is van zijn verlatingsangst aan te pakken via een behandelplan dat jij als baasje zelfstandig kan uitvoeren. Vaak duurt dit twee weken waarin je dagelijks wat kleine oefeningen doet die zich richten op het kernprobleem.'
            }, {
              title: 'Stap 3: Oefenen',
              text: 'En als je zeker weet dat hij er klaar voor is… Dan ga je als derde stap oefenen. Simpel. Door deze voorbereiding maak je tijdens het oefenen grotere stappen met veel minder risico op een terugval. Het echte probleem heb je namelijk opgelost en je hoeft nog alleen het bestaande patroon te doorbreken.'
            }].map((step, i) => <div key={i} className="flex gap-6 items-start" data-id="element-3973" data-mp="qvtwi5qjuf9f" data-mpi={i}>
                  <div className="w-12 h-12 rounded-full bg-[#5ce0d2] text-white flex items-center justify-center font-bold text-2xl flex-shrink-0 mt-1" data-id="element-3974" data-mp="79qzrv7w279n">
                    {i + 1}
                  </div>
                  <div data-id="element-3975" data-mp="gagsur5rljjo">
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-3976" data-mp="gap5qj1w0ouv">
                      {step.text}
                    </p>
                  </div>
                </div>)}
            </div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium" data-id="element-3977" data-mp="q7l59z9t60na">
              Op deze manier kan zelfs een hond die al in paniek schiet als jij
              van de bank op staat leren om stressvrij alleen thuis te blijven
              zodat jij even kan sporten, een boodschap kan doen, of iets anders
              wat voor de meeste mensen gewoon heel normaal is.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8 font-medium" data-id="element-3978" data-mp="1905tv4ih5jla">
              Zonder gepiep, geblaf of gehuil.
            </p>

            <div className="mb-16 rounded-xl overflow-hidden shadow-lg" data-id="element-3979" data-mp="13y6r9wuk6qpe">
              <img src="https://cdn.magicpatterns.com/uploads/c5dwivjBuf94wiUeGKtu3j/freepik_man-en-vrouw-van-rond-de-_2777480988.png" alt="Man en vrouw verlaten ontspannen hun huis met hond op de achtergrond" className="w-full h-auto object-cover" data-id="element-3980" data-mp="1og8k9vyt8s7" />
            </div>

            {/* 12. ICEBERG */}
            <div className="bg-[#1a2b4a] text-white rounded-2xl p-8 md:p-12 mb-16 shadow-2xl" data-id="element-3981" data-mp="kdw8ow3qmz83">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-8 text-center" data-id="element-3982" data-mp="pbemazspa2mf">
                Waarom deze methode werkt juist als nog niks gewerkt heeft
              </h2>
              <div className="flex items-center gap-5 mb-10 max-w-2xl mx-auto" data-id="element-3983" data-mp="ycw20h2742al">
                <blockquote className="text-xl italic text-gray-300 border-l-4 border-[#5ce0d2] pl-4 flex-1" data-id="element-3984" data-mp="yajjo2sizpx0">
                  "De geest is als een ijsberg. Slechts een klein deel is
                  zichtbaar boven het water." - Sigmund Freud
                </blockquote>
                <img src="https://cdn.magicpatterns.com/uploads/qmwWHyfVMxLgrevSP4D47H/sigmund.jpg" alt="Sigmund Freud" className="w-20 h-20 rounded-full object-cover flex-shrink-0 border-2 border-[#5ce0d2]" data-id="element-3985" data-mp="2smav2uyien09" />
              </div>

              <div className="space-y-6 text-gray-200 text-lg leading-relaxed" data-id="element-3986" data-mp="2euwdmsk92tvb">
                <p data-id="element-3987" data-mp="3bij140zcj1wm">
                  Het huilen, blaffen of piepen als jij van huis gaat is maar
                  een klein deel van wat er bij je hond gebeurd. Hij laat dit
                  gedrag zien omdat hij stress ervaart. Deze stress is een
                  automatische lichamelijke reflex. Deze reflex wordt
                  veroorzaakt omdat ergens diep in zijn onderbewuste brein iets
                  verkeerd gaat. Dit zien we niet direct maar deze processen
                  bepalen al zijn emoties en gedragingen.
                </p>
                <p data-id="element-3988" data-mp="3m6x2cfhcrvvg">
                  Je kan het eigenlijk zien als een ijsberg in de zee. Het
                  blaffen, piepen en gedrag dat wij "verlatingsangst" noemen is
                  wat je ziet. Dit is de <strong data-id="element-3989" data-mp="3c8ppa7q6pxyq">10% van de ijsberg</strong> die
                  boven water drijft.
                </p>
                <p data-id="element-3990" data-mp="3h7any2psg9l2">
                  Dan zijn er zijn emoties en de spanning die hij ervaart. Als
                  je goed kijkt kan je dit herkennen. Dit is het deel onderwater
                  wat je nog kan zien. Dit is nog eens <strong data-id="element-3991" data-mp="dq28tqmg3nu1">30%</strong>.
                </p>
                <p data-id="element-3992" data-mp="dswwrs4o3qs7">
                  Dan ligt er diep onderwater nog een heel groot deel van de
                  ijsberg. Dit zijn de onbewuste processen die voortkomen uit de
                  diepgewortelde behoeftes van je hond. Bij verlatingsangst is
                  er hier een kernprobleem. Dit is nog eens <strong data-id="element-3993" data-mp="whlanu4qgvuh">60%</strong>{' '}
                  van wat er eigenlijk aan de hand is.
                </p>
                <p className="font-bold text-white" data-id="element-3994" data-mp="2h7qmq3dhusna">
                  Als je verlatingsangst wilt aanpakken dan moet je aan de slag
                  met de hele ijsberg. Niet alleen met het zichtbare gedrag.
                </p>
                <p data-id="element-3995" data-mp="2pz976qhh3um6">
                  Dus als je het kernprobleem niet oplost dan heeft oefenen maar
                  10% van het effect dat je wilt. Dat is waarom direct oefenen
                  zo langzaam gaat en je hond snel terugvalt in oud gedrag. Het
                  is dan alsof je de ijsberg even onder water hebt geduwd en hij
                  weer boven komt. Dit is wat andere methodes verkeerd doen. Ze
                  beginnen direct, of veel te snel met oefenen. Daarom gaat het
                  langzaam, blijft je hond terugvallen in gedrag en vindt er
                  geen echte verandering plaats.
                </p>
                <div className="mt-8 rounded-xl overflow-hidden" data-id="element-3996" data-mp="3iqsuoml3rutz">
                  <img src="https://cdn.magicpatterns.com/uploads/dp1MNNz2c1oFtFSZvJECoy/7db3c11805f8570f0b6c849247d8d1b4.jpg" alt="Verlatingsangst IJsberg Theorie" className="w-full h-auto object-contain rounded-lg" data-id="element-3997" data-mp="3dpd6ilnmp87d" />
                </div>
              </div>
            </div>

            {/* 13. ZO PAS JE HET TOE */}
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-6" data-id="element-3998" data-mp="38e0vsbilqb7t">
              Zo pas je de Verlatingsangst Kernaanpak vandaag nog toe
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-3999" data-mp="3hgjymvme0nu2">
              De Verlatingsangst Kernaanpak Methode wordt alleen door onze
              coaches gebruikt tijdens onze behandeltrajecten. Niemand in
              Nederland werkt nog op deze manier. Maar wij vinden dat ieder
              hondenbaasje dat worstelt met de verlatingsangst van zijn hond de
              kans zou moeten krijgen om hiermee aan de slag te gaan.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-4000" data-mp="4wsfvx7fplfq">
              Daarom hebben we een videotraining gemaakt voor je. In deze
              training doorlopen we in drie compacte lessen ieder van de drie
              essentiële stappen in deze aanpak.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-4001" data-mp="em7rinty3v0e">
              {[{
              title: 'Stap 1',
              text: 'Na stap 1 begrijp je de verschillende kernproblemen van verlatingsangst en hoe je zelf een diagnose doet zodat je zeker weet dat je niet werkt aan het verkeerde probleem.'
            }, {
              title: 'Stap 2',
              text: 'Na stap 2 snap je hoe je ieder van de kernproblemen oplost zodat je hond klaar is om te oefenen en met zekerheid door kan naar stap 3.'
            }, {
              title: 'Stap 3',
              text: 'En na stap 3 snap je hoe je effectief moet oefenen met je hond zodat je zo snel mogelijk resultaat hebt.'
            }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#5ce0d2]" data-id="element-4002" data-mp="1snx10ujm40io" data-mpi={i}>
                  <h4 className="font-bold text-xl text-[#1a2b4a] mb-3" data-id="element-4003" data-mp="1juk47hifgerb">
                    {les.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-4004" data-mp="1esl0g6irzftu">
                    {les.text}
                  </p>
                </div>)}
            </div>
            <p className="text-center font-bold text-gray-500 mb-16" data-id="element-4005" data-mp="27juuu662csrq">
              Zet vandaag nog de eerste stap.
            </p>
          </div>

          {/* Right column - sticky sidebar */}
          <div className="hidden lg:block lg:col-span-4" data-id="element-4006" data-mp="1xkninmb2f467">
            <div className="sticky top-8" data-id="element-4007" data-mp="r5ml5c6e6dxi">
              <div className="bg-white rounded-xl overflow-hidden shadow-xl border border-gray-200" data-id="element-4008" data-mp="r6o5y8d7mesf">
                {/* BIJ JE BESTELLING */}
                <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-black text-sm uppercase tracking-widest" data-id="element-4009" data-mp="c2bofmei9ic8">
                  BIJ JE BESTELLING
                </div>

                <div className="p-5" data-id="element-4010" data-mp="gyttyohntkpm">
                  {/* Product */}
                  <div className="flex gap-4 items-start mb-6" data-id="element-4011" data-mp="lyy8i8z0c5d7">
                    <img src="https://cdn.magicpatterns.com/uploads/bPH8swctNa91LRo7t5rtnE/Verlatingangst_kernmethode_bonus_(3).png" alt="Verlatingsangst Kern Aanpak - Stappenplan" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-4012" data-mp="qr7y1nw7n3ey" />
                    <div data-id="element-4013" data-mp="14racf05b7epg">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-4014" data-mp="14owiiumd88jh">
                        VERLATINGSANGST KERN AANPAK - STAPPENPLAN
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-4015" data-mp="36k6u35tq5fij">
                        Gedetailleerde uitleg van hoe je de echte oorzaak van
                        verlatingsangst in 3 stappen oplost zonder dat hij
                        terugvalt in oud gedrag
                      </p>
                    </div>
                  </div>

                  {/* 5 FREE FAST ACTION BONUSES */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-5" data-id="element-4016" data-mp="1eri8gnd05r60">
                    3 x GRATIS BONUS
                  </div>

                  {/* Bonus 1 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-4017" data-mp="i3vh33uscyzf">
                    <img src="https://cdn.magicpatterns.com/uploads/kK8kyQqoZHm31F5VUdBjhD/2.png" alt="30 Dagen Community Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-4018" data-mp="i1iq6171vea8" />
                    <div data-id="element-4019" data-mp="3cmn6ijuorgh">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-4020" data-mp="3ukqpfegpfk8f">
                        30 DAGEN COMMUNITY TOEGANG
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-4021" data-mp="2a1euff6dd3ny">
                        Stuur vragen, foto's en videos naar onze experts, neem
                        deel aan meerdere wekelijkse online coachingsessies en
                        kom in contact met andere hondenbaasjes.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 2 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-4022" data-mp="2tokw3iei5982">
                    <img src="https://cdn.magicpatterns.com/uploads/jpptdiaLg8Jy3uMEh1EZiz/3.png" alt="Gezonde hond in 12 weken training" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-4023" data-mp="2xr979wqous87" />
                    <div data-id="element-4024" data-mp="18d2yjd73aqs4">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-4025" data-mp="18brk8jg0q0mr">
                        Gezonde hond in 12 weken training
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-4026" data-mp="taktdh5lce4e">
                        Methode om met natuurlijk hondenvoer en supplementen de
                        gezondheid van jouw hond in 12 weken te herstellen
                      </p>
                    </div>
                  </div>

                  {/* Bonus 3 */}
                  <div className="flex gap-3 items-start mb-6" data-id="element-4027" data-mp="fio4dlz7ykc8">
                    <img src="https://cdn.magicpatterns.com/uploads/bbcA4WNP4wTigQiHJcajRX/4.png" alt="Stoomcursus Stressless Dog Methodes" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-4028" data-mp="akw8yhzd8g3a" />
                    <div data-id="element-4029" data-mp="3sq7z4hvlz3pz">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-4030" data-mp="3sr0uynt148tc">
                        Stoomcursus Stressless Dog Methodes
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-4031" data-mp="1qz4m5ly8xd29">
                        Mini training over verschillende Stressless Dogs
                        Methodes, technieken en vaardigheden voor stressvrij
                        wandelen, hondencommunicatie, en meer.
                      </p>
                    </div>
                  </div>

                  {/* RESULTATEN */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-4" data-id="element-4032" data-mp="2d5gr3gbilac0">
                    RESULTATEN VAN DE KERNAANPAK
                  </div>

                  {/* Vimeo video */}
                  <div className="rounded-lg overflow-hidden" data-id="element-4033" data-mp="1kjnvprsjsxz9">
                    <div style={{
                    padding: '56.25% 0 0 0',
                    position: 'relative'
                  }} data-id="element-4034" data-mp="1pfcqlhtmhqp8">
                      <iframe src="https://player.vimeo.com/video/1158372685?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%'
                    }} title="Resultaten video" data-id="element-4035" data-mp="30vjg1nk4u06e"></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. LETTER SECTION */}
      <section className="bg-white py-16" data-id="element-4036" data-mp="nhgal94fsnw9">
        <div className="max-w-6xl mx-auto px-4" data-id="element-4037" data-mp="ng5bhmlxs4bh">
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] text-center mb-4" data-id="element-4038" data-mp="ikg8taeme7ay">
            RESULTATEN VAN DE KERNAANPAK
          </h2>
          <p className="text-center text-lg text-gray-700 max-w-3xl mx-auto mb-8" data-id="element-4039" data-mp="2pbpelptznqic">
            Dit is hoe ik honden met verlatingsangst help om stressvrij alleen
            thuis te blijven door eerst het onderliggende kernprobleem aan te
            pakken, dit maakt de verdere aanpak veel en veel makkelijker
          </p>

          <p className="text-xl font-bold text-[#5ce0d2] mb-12 text-center leading-relaxed max-w-3xl mx-auto" data-id="element-4040" data-mp="q3fpv9elzmr5">
            Deze aanpak is nieuw, compleet anders, en verschilt van de eerdere
            aanpakken die je tot nu toe kent - lees mijn verhaal hieronder over
            het ontstaan van de Verlatingsangst Kernaanpak
          </p>

          <div className="grid lg:grid-cols-12 gap-8" data-id="element-4041" data-mp="l5e6end9tlf5">
            {/* Left column - letter content */}
            <div className="lg:col-span-8" data-id="element-4042" data-mp="75we3y0rnq11">
              <div className="bg-[#faf5eb] rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-4043" data-mp="c2wmwgp036vu">
                <div className="prose prose-lg max-w-none text-gray-800" data-id="element-4044" data-mp="21hkwka67iaq6">
                  <p className="font-bold" data-id="element-4045" data-mp="21g9pa0djykub">
                    Beste toekomstige Verlatingsangst Kernaanpakker
                  </p>
                  <p data-id="element-4046" data-mp="389ledrsdcjja">
                    <strong data-id="element-4047" data-mp="38a4ud2ygkxuo">Van:</strong> Amee Buijs
                  </p>
                  <p data-id="element-4048" data-mp="3d753xnuioiqj">
                    <strong data-id="element-4049" data-mp="3d8omjl3nb5vh">Re:</strong> De enige manier om verlatingsangst écht
                    op te lossen, is door je op het kernprobleem te focussen (en
                    niet op het oefenen).
                  </p>
                  <p data-id="element-4050" data-mp="3mzsz6e5umen5">
                    Misschien verbaast het je dat er een andere manier is dan
                    eindeloos oefenen waarmee je verlatingsangst sneller kunt
                    oplossen, met een minimale kans op terugval.
                  </p>
                  <p data-id="element-4051" data-mp="4t4w0tud01k4">En dat is niet gek.</p>
                  <p data-id="element-4052" data-mp="4qaaeyzm0ap4">
                    Want bijna alles wat je online vindt, draait om
                    symptoombestrijding: oefenschema's, sleutels rammelen, je
                    hond laten uitblaffen, of afleiden bij vertrek.
                  </p>
                  <p data-id="element-4053" data-mp="2bjcf27jcn9ty">
                    Geen van deze methodes focust zich op het échte,
                    onderliggende probleem.
                  </p>
                  <p data-id="element-4054" data-mp="1z8blqmm703nq">
                    Waarom zou mijn verhaal dan wel waar zijn? Je kunt immers
                    niet alles geloven wat je op het internet leest.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] mt-8" data-id="element-4055" data-mp="1pa5o4h7f5joo">
                    Dus laat het me je bewijzen.
                  </p>
                  <div className="bg-white p-6 rounded-lg my-8 text-sm italic text-gray-600 border-l-4 border-gray-300" data-id="element-4056" data-mp="2mwuypfg6t4m5">
                    <strong data-id="element-4057" data-mp="2hzcl3br8617t">Maar lees eerst deze disclaimer:</strong> Ik heb het
                    voordeel van jarenlange ervaring en het doorbreken van oude
                    methodes. De gemiddelde persoon die een "zo-doe-je-dat"
                    methode volgt, behaalt weinig tot geen resultaten. Jouw
                    resultaten zijn afhankelijk van vele factoren, waaronder
                    vooral je bereidheid om te doen wat er in de methode staat.
                    Elke verandering vraagt om inzet en doorzettingsvermogen.
                    Als je daar niet toe bereid bent, dan is deze methode
                    misschien niet voor jou. Met dat gezegd, laat me je laten
                    zien hoe het anders kan.
                  </div>

                  <p className="font-bold text-2xl text-[#1a2b4a] mt-12 mb-6" data-id="element-4058" data-mp="3frj9i3n7q5v2">
                    Ik werk met een compleet andere methode die ik nu met jou ga
                    delen.
                  </p>
                  <p data-id="element-4059" data-mp="35v6ft5ro3s0b">
                    Dit is dezelfde Verlatingsangst-Kernaanpak model die
                    honderden hondeneigenaren nu gebruiken om de paniek bij hun
                    hond écht op te lossen.
                  </p>
                  <p data-id="element-4060" data-mp="2wzqds1gre6jn">
                    Hierdoor krijgen zij hun spontane vrijheid terug, sneller
                    dan ze ooit voor mogelijk hielden.
                  </p>
                  <p data-id="element-4061" data-mp="2n35dftfopjm5">
                    En het mooiste van alles? Ze bouwen een diepere, betere band
                    op met hun hond, gebaseerd op begrip in plaats van
                    frustratie.
                  </p>
                  <p className="font-bold" data-id="element-4062" data-mp="1zimkcof1yqwa">
                    Dit is niet zomaar een stappenplan;
                  </p>
                  <p data-id="element-4063" data-mp="28h80ye0yrvuf">
                    Het is een fundamenteel andere manier van denken over
                    verlatingsangst. We focussen ons niet op:
                  </p>
                  <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-4064" data-mp="2med3i41gyckx">
                    <li data-id="element-4065" data-mp="2iembxy44bsfc">
                      Eindeloze, korte oefensessies die nergens toe leiden.
                    </li>
                    <li data-id="element-4066" data-mp="2w8de2lfisa11">Je hond negeren of laten blaffen tot hij stopt.</li>
                    <li data-id="element-4067" data-mp="2r87t1o3r9lrx">Trucjes om je hond af te leiden bij vertrek.</li>
                    <li data-id="element-4068" data-mp="365rrsda26kpn">
                      Standaard protocollen die geen rekening houden met jouw
                      unieke hond.
                    </li>
                  </ul>
                  <p className="font-bold text-xl text-[#5ce0d2] p-6 bg-[#e6f7f5] rounded-lg my-8" data-id="element-4069" data-mp="yjqc9temwm53">
                    In plaats daarvan doen we iets wat bijna niemand doet: we
                    beginnen met een diagnose om het échte kernprobleem te
                    vinden.
                  </p>
                  <p data-id="element-4070" data-mp="1d84dy10be4k2">
                    Dit is een compleet andere aanpak, en het heeft de kracht om
                    alles voor jou en je hond te veranderen. Ik weet dat dit
                    waar is, want het heeft alles voor mij veranderd.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-4071" data-mp="pia3tr7dqu3i">
                    Hoe ik dit ontdekte: De "Cirkel van Wanhoop" bij mijn
                    klanten
                  </h3>
                  <p data-id="element-4072" data-mp="20xp7fdu3gk7l">
                    Als gedragsdeskundige zag ik dit patroon steeds terugkomen
                    bij mijn klanten. Ik noem het de "Cirkel van Wanhoop":
                  </p>
                  <div className="bg-white border border-gray-200 rounded-lg p-6 my-6 space-y-3 shadow-sm" data-id="element-4073" data-mp="3qeb2dmpg2uu5">
                    <p data-id="element-4074" data-mp="3ley485t4i1c9">
                      <strong data-id="element-4075" data-mp="3lgj1i36tnydt">Stap 1:</strong> Ze volgden online oefenschema's
                      en begonnen met 30 seconden de deur uit.
                    </p>
                    <p data-id="element-4076" data-mp="3bpy0ya7l8js9">
                      <strong data-id="element-4077" data-mp="3bomz4fxpdm3s">Stap 2:</strong> De hond blafte, dus ze gingen te
                      snel. Terug naar 10 seconden.
                    </p>
                    <p data-id="element-4078" data-mp="36o8r2xw3qc5r">
                      <strong data-id="element-4079" data-mp="32ogpx691f8af">Stap 3:</strong> Na een week kon de hond een
                      minuut alleen zijn. Een klein succes!
                    </p>
                    <p data-id="element-4080" data-mp="2xq5cymng4hnz">
                      <strong data-id="element-4081" data-mp="2sqsjhj22kccf">Stap 4:</strong> Ze probeerden vijf minuten, en de
                      hond raakte volledig in paniek.
                    </p>
                    <p data-id="element-4082" data-mp="vy0fywr3au6e">
                      <strong data-id="element-4083" data-mp="vwftluexihjm">Stap 5:</strong> De buren klaagden. Ze voelden
                      zich slechte eigenaren.
                    </p>
                    <p data-id="element-4084" data-mp="2lfe2m5cx2idy">
                      <strong data-id="element-4085" data-mp="2le31kdauvoqj">Stap 6:</strong> Ze gaven het op en regelden weer
                      een oppas voor elke boodschap.
                    </p>
                    <p data-id="element-4086" data-mp="2bhq9fjuylixw">
                      <strong data-id="element-4087" data-mp="2bij8dynof45h">Stap 7:</strong> Na een paar weken frustratie
                      begonnen ze weer bij Stap 1.
                    </p>
                  </div>
                  <p data-id="element-4088" data-mp="346f3iyxlko05">
                    Ik zag hoe deze cirkel mijn klanten jarenlang gevangen
                    hield. Ze voelden zich machteloos en schuldig.
                  </p>
                  <p data-id="element-4089" data-mp="2u7zmjosaav4d">
                    Ik voelde me gefrustreerd omdat ik zag dat ik hen niet echt
                    hielp. Ik was aan het symptoombestrijden, niet aan het
                    oplossen.
                  </p>
                  <p data-id="element-4090" data-mp="1isjaijrlerc4">
                    Ik stond op het punt om te geloven dat verlatingsangst bij
                    sommige honden gewoon onoplosbaar was.
                  </p>
                  <p data-id="element-4091" data-mp="5u0nwxwlzmzw">
                    Maar voordat ik dit opgaf, wilde ik nog één ding proberen.
                    Iets wat, als het zou werken, alles zou veranderen.
                  </p>
                  <p className="font-bold" data-id="element-4092" data-mp="eup2putttrdu">En het werkte.</p>

                  <div className="my-12 flex flex-col md:flex-row gap-8 items-center" data-id="element-4093" data-mp="eu5u54q2gfch">
                    <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee Buijs" className="w-48 h-48 rounded-full object-cover shadow-xl border-4 border-white" data-id="element-4094" data-mp="atvcgusww0hs" />
                    <div data-id="element-4095" data-mp="3s2s7ll9mjuv2">
                      <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-4096" data-mp="3nasb62srjk38">
                        Mijn naam is Amee, en ik zag jouw frustratie bij al mijn
                        klanten.
                      </h3>
                      <div className="space-y-4" data-id="element-4097" data-mp="2vk4bkv6qmmro">
                        <p data-id="element-4098" data-mp="2vjch5novmv2z">
                          Als gedragsdeskundige zag ik steeds dezelfde pijn.
                          Honden die ondanks alle liefde en zorg in pure paniek
                          raakten zodra de deur dichtging.
                        </p>
                        <p data-id="element-4099" data-mp="3tea7x5n2eo3c">
                          Eigenaren, vooral vrouwen van 50+, die hun hele leven
                          om hun hond heen planden.
                        </p>
                        <p data-id="element-4100" data-mp="76sggqu80u6w">
                          Geen spontaan kopje koffie met een vriendin, niet meer
                          naar yoga, altijd die knoop in je maag als je de deur
                          uit moest.
                        </p>
                      </div>
                    </div>
                  </div>

                  <p data-id="element-4101" data-mp="kygrsrwnbemt">
                    Ze voelden zich gevangen in hun eigen huis, schuldig
                    tegenover hun hond, en bezwaard naar de omgeving die altijd
                    moest bijspringen.
                  </p>
                  <p data-id="element-4102" data-mp="151cv9e9y1mvd">
                    En ik zag dat mijn standaard aanpak hen niet echt hielp.
                  </p>
                  <p data-id="element-4103" data-mp="1020cp5q3v1yl">
                    Het keerpunt kwam bij een klant met een hond die meerdere
                    problemen had. We kregen de verlatingsangst niet opgelost
                    met de standaard aanpak.
                  </p>
                  <p data-id="element-4104" data-mp="r3eksjyqual5">
                    Pas toen we aan de slag gingen met een andere angst die hij
                    had – iets in zijn omgeving – gebeurde er iets magisch. De
                    verlatingsangst verdween daarna als sneeuw voor de zon.
                  </p>
                  <p data-id="element-4105" data-mp="1e0q7gepgcpjs">
                    Het was een Eureka-moment. Ineens viel alles op zijn plek.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] my-6" data-id="element-4106" data-mp="19yd4tz6057r8">
                    Verlatingsangst was niet het probleem; het was een symptoom.
                  </p>
                  <p data-id="element-4107" data-mp="21qu2vyshlizp">En dat veranderde alles in hoe ik werkte.</p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-4108" data-mp="10sky0455p3n">
                    De #1 Fout die iedereen maakt: focussen op het symptoom
                  </h3>
                  <p data-id="element-4109" data-mp="3nfu45htugqtn">
                    De markt voor hondentraining is verdeeld in twee kampen. Je
                    hebt de "symptoombestrijders" en je hebt ons van Stressless
                    Dogs, wij zijn de "kernaanpakkers".
                  </p>
                  <p data-id="element-4110" data-mp="3egqjwaixy5dk">
                    Maar jarenlang was ik ook een symptoombestrijder. Ik
                    probeerde mijn klanten te helpen door het blaffen, piepen en
                    slopen af te leren.
                  </p>
                  <p data-id="element-4111" data-mp="30fe727z2ujvw">
                    Maar het probleem is niet het gedrag zelf. Het probleem is
                    de onderliggende emotie die het gedrag veroorzaakt.
                  </p>
                  <p className="font-bold text-red-600" data-id="element-4112" data-mp="yo1emieaq4gq">
                    Het gevaarlijkste advies dat je kunt krijgen, is "gewoon
                    oefenen en laten wennen".
                  </p>
                  <p data-id="element-4113" data-mp="2lkr5pnmdtye2">
                    Waarom? Omdat je daarmee de onderliggende stress negeert.
                  </p>
                  <p data-id="element-4114" data-mp="2qaxt5k55rcuq">
                    Soms verergert het de situatie zelfs, waardoor de stress
                    overslaat op andere aspecten van het leven van je hond. Je
                    bent de paniek aan het managen, niet aan het oplossen.
                  </p>
                  <p data-id="element-4115" data-mp="22lvcofm9fq1t">
                    De oplossing gaat tegen je gevoel in: stop met focussen op
                    het oefenen van alleen zijn. In plaats daarvan richten we
                    ons op de wortel van het probleem.
                  </p>
                  <p data-id="element-4116" data-mp="2bncsdwvr9ppz">
                    Is het verveling? Trauma? Omgevingsangst? Of een van de
                    andere vijf kernproblemen?
                  </p>
                  <p className="font-bold" data-id="element-4117" data-mp="3n16zhoclhmtk">
                    Zodra je de diagnose stelt en het kernprobleem aanpakt,
                    wordt het oefenen verrassend eenvoudig en effectief.
                  </p>

                  <h3 className="text-2xl font-black text-[#1a2b4a] mt-12 mb-8" data-id="element-4118" data-mp="1iwu34h1gcvak">
                    Wat je leert in deze training:
                  </h3>
                  <div className="space-y-6 not-prose" data-id="element-4119" data-mp="1ryk4ofp1tam2">
                    {[{
                    title: 'Stap 1: De Diagnose',
                    text: 'Leer de verschillende oorzaken van verlatingsangst en hoe je ontdekt welke oorzaak bij jouw hond speelt.'
                  }, {
                    title: 'Stap 2: De Kernaanpak',
                    text: 'Krijg de tools om de specifieke kernproblemen op te lossen en een sterke, veerkrachtige basis te leggen voor je hond.'
                  }, {
                    title: 'Stap 3: Het Oefenen',
                    text: 'Leer hoe je stressvrij en effectief kunt oefenen, op een manier die past bij jouw hond, zodat je snel en blijvend resultaat boekt.'
                  }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 flex gap-4 items-start" data-id="element-4120" data-mp="2wzjpe2nvgq04" data-mpi={i}>
                        <PlayCircle className="w-8 h-8 text-[#5ce0d2] flex-shrink-0 mt-1" data-id="element-4121" data-mp="2n5kmv2jvz47n" />
                        <div data-id="element-4122" data-mp="3av5ahyqzipn9">
                          <h4 className="font-bold text-xl text-[#1a2b4a] mb-2" data-id="element-4123" data-mp="3fw2rw9467fnp">
                            {les.title}
                          </h4>
                          <p className="text-gray-700 m-0" data-id="element-4124" data-mp="31w1nwkslzs40">{les.text}</p>
                        </div>
                      </div>)}
                  </div>
                  <p className="text-gray-600 mt-8 italic" data-id="element-4125" data-mp="1qgd3a02tv56d">
                    Daarnaast krijg je toegang tot casestudies en interviews met
                    klanten, zodat je precies ziet hoe deze aanpak in de
                    praktijk werkt.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-4126" data-mp="25zo2lspy0ww8">
                    Voor wie is deze methode (niet)?
                  </h3>
                  <p data-id="element-4127" data-mp="210kyqblp8wpu">
                    Deze methode is <strong data-id="element-4128" data-mp="1wyzoyz4goyjv">niet</strong> voor mensen die hun
                    hond zien als een robot die moet gehoorzamen. Het is niet
                    voor mensen die een snelle, magische oplossing zoeken zonder
                    bereid te zijn hun hond echt te begrijpen.
                  </p>
                  <p data-id="element-4129" data-mp="2ko25u4r9undb">
                    Deze methode is <strong data-id="element-4130" data-mp="2kmzczrae2aur">voor jou</strong> als je je hond
                    ziet als een volwaardig gezinslid. Als je gelooft dat hij
                    emoties en gevoelens heeft die gerespecteerd moeten worden.
                    En als je bereid bent om het anders te doen, op een manier
                    die op de lange termijn beter is voor zowel jou als je hond.
                  </p>
                  <p className="text-xl font-bold text-[#5ce0d2] mt-8 mb-12" data-id="element-4131" data-mp="3fyp4fv2mu1j4">
                    Als je klaar bent om de cirkel van wanhoop te doorbreken en
                    je vrijheid terug te krijgen, dan is dit het moment. Stop
                    met symptoombestrijding en start met de kernaanpak.
                  </p>

                  <div className="rounded-xl overflow-hidden shadow-lg mt-8" data-id="element-4132" data-mp="3tqwxpcupjad2">
                    <img src="https://cdn.magicpatterns.com/uploads/bEbEj36tRb2txwLv3vaAfN/freepik_man-en-vrouw-van-rond-de-_2777484675.png" alt="Man en vrouw kijken naar ontspannen hond" className="w-full h-auto object-cover" data-id="element-4133" data-mp="2hzr1mmda465" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - sticky sidebar */}
            <div className="lg:col-span-4" data-id="element-4134" data-mp="2i9dp14ycyf74">
              <div className="lg:sticky lg:top-8 space-y-6" data-id="element-4135" data-mp="2ia5ncnjcar13">
                {/* Product image */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-4136" data-mp="3ll2zeowz8wxw">
                  <img src="https://cdn.magicpatterns.com/uploads/wdHvRUEhLbVnqomgf29M7C/d2e92536bec5d1aca3fcae847f833a85.jpg" alt="Verlatingsangst Kernaanpak Training op verschillende apparaten" className="w-full h-auto object-contain" data-id="element-4137" data-mp="3gn18xix81vce" />
                </div>

                {/* Wat je krijgt */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-4138" data-mp="3dwtrq88f9ei">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-4139" data-mp="i2j5lhynhj0z">
                    Dit is wat je krijgt met de training
                  </div>
                  <div className="p-5 space-y-5" data-id="element-4140" data-mp="r3r4a152wlvl">
                    <div className="flex items-start gap-3" data-id="element-4141" data-mp="r2g0w2fjpg50">
                      <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-4142" data-mp="m6h882n6pbys" />
                      <span className="text-sm font-bold text-gray-800" data-id="element-4143" data-mp="15qy6nigi0biv">
                        Drie stappen kernaanpak om jouw hond te leren alleen
                        thuis te blijven
                      </span>
                    </div>

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-4144" data-mp="wsm7gs1kg5et">
                      Dit leer je in Les 1
                    </p>
                    {['Hoezo oefenen met alleen thuis zijn geen nut heeft als je niet eerst het onderliggende probleem aanpakt', 'Welke onderliggende kernproblemen er zijn bij verlatingsangst en welke er voor jouw hond waarschijnlijk speelt', 'Hoe je zelf een diagnose doet zodat je weet waarmee je eerst aan de slag moet'].map((item, i) => <div key={`l1-${i}`} className="flex items-start gap-3" data-id="element-4145" data-mp="436tpuiinyf7" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-4146" data-mp="918fin7bubud" />
                        <span className="text-sm text-gray-700" data-id="element-4147" data-mp="oji1g4pyf4zc">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-4148" data-mp="jl6ty0n4t6ka">
                      Dit leer je in Les 2
                    </p>
                    {['Hoe je een effectief behandelplan maakt voor jouw hond zodat je in de juiste volgorde aan de slag gaat', 'Wat je wel, en wat je juist niet moet oefenen zodat je geen tijd en energie stopt in de verkeerde dingen', 'Voorbeeld casus van hond Lemmy en hoe deze van totaal niet alleen kon zijn na 3 weken 3 uur alleen kon zijn met deze methode', 'Voorbeeld casus van honden Mork & Dash en hoe ook die hun verlatingsangst in korte tijd overwonnen met deze methode'].map((item, i) => <div key={`l2-${i}`} className="flex items-start gap-3" data-id="element-4149" data-mp="3dzxkhrncknl5" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-4150" data-mp="3e20jh16h9r20" />
                        <span className="text-sm text-gray-700" data-id="element-4151" data-mp="1thlrqdc52dtp">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-4152" data-mp="22iju6r6xida6">
                      Dit leer je in Les 3
                    </p>
                    {['Effectief oefenplan zodat je op de juiste manier zijn tijd alleen opbouwt', 'Drie voorbeeld behandel- en oefenplannen met verschillende onderliggende problemen'].map((item, i) => <div key={`l3-${i}`} className="flex items-start gap-3" data-id="element-4153" data-mp="1jsbvqme6cb0b" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-4154" data-mp="1jq8v78feazhc" />
                        <span className="text-sm text-gray-700" data-id="element-4155" data-mp="1okvbnq0c3i8a">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-4156" data-mp="w27tojgmwjbf">
                      Dit leer je in de bonus lessen
                    </p>
                    {['Herkennen van blafsoorten zodat je aan het type geblaf kan horen waarom hij blaft (angst, eenzaamheid, verveling, etc)', 'Stress signalen herkennen zodat je weet of je hond hoog of laag in zijn stress zit en het wel of geen goed moment is om te oefenen', '3 Kalmerende activiteiten waarmee je jouw hond kan helpen ontspannen als zijn stress level te hoog is'].map((item, i) => <div key={`bonus-${i}`} className="flex items-start gap-3" data-id="element-4157" data-mp="3nyyrpkblw519" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-4158" data-mp="3e8dlpbtlry8b" />
                        <span className="text-sm text-gray-700" data-id="element-4159" data-mp="3e616h6f8c1yy">{item}</span>
                      </div>)}
                  </div>
                </div>

                {/* First pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-4160" data-mp="2llnjrq3fu5kc">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-4161" data-mp="2gn2jjqo6rlvw">
                    Start met de Verlatingsangst Kernaanpak Methode
                  </div>
                  <div className="p-5 text-center" data-id="element-4162" data-mp="2ql9w7xbfzhs3">
                    <img src="https://cdn.magicpatterns.com/uploads/wdHvRUEhLbVnqomgf29M7C/d2e92536bec5d1aca3fcae847f833a85.jpg" alt="Verlatingsangst Kernaanpak Training" className="w-full h-auto object-contain mb-4 rounded-lg" data-id="element-4163" data-mp="2qjfeervgw5s8" />
                    <div className="text-[#e53e3e] font-black text-3xl mb-1" data-id="element-4164" data-mp="3ecnok39lfdd2">
                      Slechts €27
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-4165" data-mp="3nardzanp8ua5">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-4166" data-mp="3jb8riag8cb57">
                      Start met de methode voor €27. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <p className="text-[#5ce0d2] font-bold text-sm mb-4" data-id="element-4167" data-mp="3v9ultllu6d7c">
                      Per direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak-g" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-4168" data-mp="8ww3xk2qkr1d">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-4169" data-mp="rv8glfsuwj1p">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-4170" data-mp="2tltnkndr8h4b">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-4171" data-mp="1asil2x7oabw1">
                    Dit is wat anderen zeggen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-4172" data-mp="11yx6pezf6wn5">
                    <img src="https://cdn.magicpatterns.com/uploads/qadgiKJVMEENSSwLSHdnib/Scherm­afbeelding_2026-04-13_om_16.11.42.png" alt="Review Marijke" className="w-full h-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-4173" data-mp="11zopfp7x4zw0" />
                    <img src="https://cdn.magicpatterns.com/uploads/pu6bXE2Mf7TwUeQJ5i8sft/Scherm­afbeelding_2026-04-13_om_16.11.31.png" alt="Review Lut Matthys" className="w-full h-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-4174" data-mp="1pmn3yhch9xra" />
                  </div>
                </div>

                {/* Second pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-4175" data-mp="4drgaiffi6wq">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-4176" data-mp="1s69vifxhybuv">
                    Start met de Verlatingsangst Kernaanpak Training
                  </div>
                  <div className="p-5 text-center" data-id="element-4177" data-mp="1j5ledcct3vdr">
                    <div className="text-[#e53e3e] font-black text-2xl mb-1" data-id="element-4178" data-mp="1o7aqywfogh3y">
                      Slechts €27 vandaag
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-4179" data-mp="2bu969qs29j0a">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-4180" data-mp="21yp9l25oagah">
                      Start met de methode voor €27. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak-g" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-4181" data-mp="qhzcq9n530tj">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-4182" data-mp="wxy3pcmj8ga9">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Bonussen */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-4183" data-mp="4av56khuw5k0">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-4184" data-mp="al3vl50e3bh">
                    Inclusief Bonussen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-4185" data-mp="996fewc2ci2r">
                    {[{
                    title: '30 dagen community toegang',
                    desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies en kom in contact met andere hondenbaasjes."
                  }, {
                    title: 'Gezonde hond in 12 weken',
                    desc: 'Methode om met natuurlijk hondenvoer en supplementen de gezondheid van jouw hond in 12 weken te herstellen'
                  }, {
                    title: 'Stoomcursus Stressless Dog Methodes',
                    desc: 'Mini training over verschillende Stressless Dogs Methodes, technieken en vaardigheden voor stressvrij wandelen, hondencommunicatie, en meer.'
                  }].map((bonus, i) => <div key={`b-${i}`} className="flex items-start gap-3" data-id="element-4186" data-mp="17ooscjt2gctj" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-4187" data-mp="1bp8opl5tfcem" />
                        <div data-id="element-4188" data-mp="2j0xya2t35sqa">
                          <p className="font-bold text-sm text-[#1a2b4a]" data-id="element-4189" data-mp="2j3tvtq10ufe7">
                            {bonus.title}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-4190" data-mp="beo3jke2gcrd">{bonus.desc}</p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Video Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-4191" data-mp="2lb1nsy0y0t5">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-4192" data-mp="3trw0hyubmd0q">
                    Video Testimonials & Interviews
                  </div>
                  <div className="p-5 space-y-4" data-id="element-4193" data-mp="3jtzicn2yuht4">
                    {['1158442858', '1158442995', '1158442918', '1158443130'].map(id => <div key={id} className="rounded-lg overflow-hidden shadow-sm" data-id="element-4194" data-mp="1e341vsv2hb6w">
                        <iframe src={`https://player.vimeo.com/video/${id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" className="w-full aspect-video" title={`Testimonial ${id}`} data-id="element-4195" data-mp="191eow7oaang6"></iframe>
                      </div>)}
                  </div>
                </div>

                {/* Final CTA */}
                <div className="bg-[#e6f7f5] rounded-xl p-5 text-center border border-[#5ce0d2]" data-id="element-4196" data-mp="39r13yo0uz0f">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-3" data-id="element-4197" data-mp="3lfdq35n789hi">
                    3 stappen tot je hond ontspannen alleen kan blijven
                  </p>
                  <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak-g" className="block w-full bg-[#5ce0d2] hover:bg-[#4bc9bd] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-md text-sm" data-id="element-4198" data-mp="3qfs20yrx83kt">
                    Start nu met de Verlatingsangst Kernaanpak
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 19. GUARANTEE */}
      <section className="bg-[#1a2b4a] text-white py-16" data-id="element-4199" data-mp="3e3zb5xhlwplo">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-4200" data-mp="3e2eg86rdr4na">
          <img src="https://cdn.magicpatterns.com/uploads/tPvpNvykR2KiCNK1pkG2LG/1a50ac51aa1d734ab9af0a73cc65b51b.png" alt="100% Money Back Guarantee" className="w-32 h-32 mx-auto mb-6 object-contain" data-id="element-4201" data-mp="3ru2vgiwxe98h" />
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-[#ffb800]" data-id="element-4202" data-mp="5ljrrwbbxmsq">
            De BESTE Geld-Terug Garantie In De Wereld
          </h2>
          <h3 className="text-2xl font-bold mb-8" data-id="element-4203" data-mp="27gal0pp4m3d8">
            365 dagen niet-goed, geld-terug garantie:
          </h3>
          <div className="text-lg text-gray-300 leading-relaxed space-y-6 max-w-3xl mx-auto text-left" data-id="element-4204" data-mp="22hqx4jqz2hi8">
            <p data-id="element-4205" data-mp="3vjwyia35y8yh">
              Kijk, laat me eerlijk tegen je zijn: Ik weet dat voordat ik ergens
              induik… …ik zelf ook wil weten wat ik koop en dat het wordt
              ondersteund door een sterke geld-terug-garantie. En ik wil dat jij
              je comfortabel voelt bij deze aankoop. Ook al is het maar €27 –
              jij hebt voor dat geld gewerkt en het telt.
            </p>
            <p data-id="element-4206" data-mp="3cmvvuvx30kxp">
              Zoals mijn opa altijd zei: "Maak eerst een proefrit, voordat je de
              auto van het terrein afrijdt." Maar hier zit het verschil. Waar de
              meeste mensen je maximaal een garantie van 14 of 30 dagen zouden
              geven… ga ik iets doen wat je waarschijnlijk nog nooit hebt
              gezien.
            </p>
            <p className="font-bold text-white text-xl text-center py-4" data-id="element-4207" data-mp="11tj9jdg6t6y6">
              Ik geef je een 365 dagen om de Verlatingsangst Kernaanpak Training
              te bekijken en toe te passen.
            </p>
            <p data-id="element-4208" data-mp="14e8rwrv8t3o0">
              Ja, je leest het goed. Je krijgt een heel JAAR om deze korte
              training te volgen en toe te passen wat je erin leert. Niet
              slechts een paar weken of een maand. En als je niet volledig
              overdonderd bent door wat je leert… Dan stuur je me gewoon een
              e-mail en vraag je op elk moment binnen die 365 dagen je geld
              terug. We storten je €27 direct terug en je mag toegang tot de
              cursus gratis houden.
            </p>
            <p className="text-center italic mt-8" data-id="element-4209" data-mp="1s6pd3baa1brj">
              Omdat je nu nog aan het gelezen ben, neem ik aan dat je klaar bent
              om te bestellen, dus met die gedachten...
            </p>
          </div>
        </div>
      </section>

      {/* 20. PRICING CTA */}
      <section className="bg-white py-16 border-b border-gray-200" data-id="element-4210" data-mp="262t4yxxoh80u">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-4211" data-mp="2avcglpct1t30">
          <h2 className="text-4xl font-black text-[#1a2b4a] mb-2" data-id="element-4212" data-mp="2awxe9nuf1s53">
            Vandaag voor €27
          </h2>
          <h3 className="text-2xl font-bold text-[#e53e3e] mb-6" data-id="element-4213" data-mp="2gphmj55mgrvf">
            (Bespaar €70)
          </h3>
          <img src="https://cdn.magicpatterns.com/uploads/cn6aNStyPs26sEQni2fyTV/Ontwerp_zonder_titel_(21).jpg" alt="Verlatingsangst Kernaanpak Stappenplan" className="w-full max-w-md mx-auto mb-8 mix-blend-multiply" data-id="element-4214" data-mp="2bq4s9zcf8iit" />
          <p className="text-lg text-gray-600 mb-8" data-id="element-4215" data-mp="21ubgwjafuv2m">
            Start met de Verlatingsangst Kernaanpak voor{' '}
            <span className="line-through" data-id="element-4216" data-mp="1wznt6mn9e4p3">€97</span> slechts €27! Direct
            toegang tot online lesmateriaal. Neem de eerste stap in 2 minuten.
          </p>
          <div className="max-w-md mx-auto" data-id="element-4217" data-mp="1o2dgcwusm7i2">
            <CTAButton data-id="element-4218" data-mp="1j1fykldp3fh3" />
            <p className="text-sm text-gray-500 mt-4 font-bold" data-id="element-4219" data-mp="1j1z5z85pylgv">
              Met 365 dagen 100% geld terug garantie.
            </p>
          </div>
        </div>
      </section>

      {/* 21. WHAT YOU GET GRID */}
      <section className="bg-[#faf5eb] py-16" data-id="element-4220" data-mp="13xwbq20odi2o">
        <div className="max-w-6xl mx-auto px-4" data-id="element-4221" data-mp="18xsig90rbnlx">
          <h2 className="text-3xl font-black text-[#1a2b4a] text-center mb-12" data-id="element-4222" data-mp="18whdw6zhmbtr">
            Dit is wat je krijgt met de training
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-4223" data-mp="1dv0yo42chhkj">
            {[{
            title: 'Verlatingsangst Kernaanpak Methode',
            desc: 'Volledige training in hoe je de Verlatingsangst Kernaanpak inzet.',
            image: 'https://cdn.magicpatterns.com/uploads/d7mvv6jB1XyRHfPv1QLUbd/Verlatingangst_kernmethode_bonus_(2).png'
          }, {
            title: '30 dagen ondersteuning via Community',
            desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies.",
            image: 'https://cdn.magicpatterns.com/uploads/8mzMhue5NATuWpex23cfs6/2.png'
          }, {
            title: 'Stoomcursus Stressless Dog Methodes',
            desc: 'Mini training over verschillende Stressless Dogs Methodes, technieken en vaardigheden voor stressvrij wandelen, hondencommunicatie, en meer.',
            image: 'https://cdn.magicpatterns.com/uploads/5xTMXACWhxH6FRP25sk6Rf/4.png'
          }, {
            title: 'Gezonde hond in 12 weken training',
            desc: 'Methode om met natuurlijk hondenvoer en supplementen de gezondheid van jouw hond in 12 weken te herstellen.',
            image: 'https://cdn.magicpatterns.com/uploads/dAT5SmJ1D7wjLPsXTfaXi4/3.png'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl overflow-hidden shadow-md flex flex-col h-full" data-id="element-4224" data-mp="2wtqhqvo2l7yo" data-mpi={i}>
                <div className="bg-[#5ce0d2] text-[#1a2b4a] font-bold text-center py-2 text-xs uppercase tracking-wider" data-id="element-4225" data-mp="12itxm23m2z3i">
                  INBEGREPEN BIJ JE BESTELLING
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-4226" data-mp="3j2xckx34fi98">
                  <div className="w-full h-48 rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-4227" data-mp="34f2ltm8obnys">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain" data-id="element-4228" data-mp="39dnixcsmprj0" />
                  </div>
                  <h4 className="font-bold text-[#1a2b4a] mb-2 leading-tight" data-id="element-4229" data-mp="30dr0vu0qvqwx">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-auto" data-id="element-4230" data-mp="2li1bdlwcovng">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 22. BOTTOM CTA BAR */}
      <div className="bg-[#ffb800] py-8 text-center px-4" data-id="element-4231" data-mp="jmqyn7d99imt">
        <div className="max-w-md mx-auto" data-id="element-4232" data-mp="omvfwzlzmhe3">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak-g" className="block w-full bg-[#1a2b4a] hover:bg-black text-white font-bold py-4 px-4 rounded-lg text-xl transition-colors shadow-lg" data-id="element-4233" data-mp="olu24ndl7gso">
            Krijg nu toegang!
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-4234" data-mp="daemj3eqlfo7">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 24. TURID RUGAAS QUOTE */}
      <section className="bg-white py-16" data-id="element-4235" data-mp="15zd4o0iv0hti">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8" data-id="element-4236" data-mp="10xw6wdvo9bh5">
          <div className="flex-1 text-center md:text-left" data-id="element-4237" data-mp="w6xmb23nhr83">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-4238" data-mp="w5cwtqw70yh3">
              Meestal zijn wij, de menselijke soort, degenen die conflicten
              creëren tussen onze honden en onszelf
            </h2>
            <p className="text-lg text-gray-700 mb-2" data-id="element-4239" data-mp="1jwibw3ub7mqc">
              <strong data-id="element-4240" data-mp="1juxfs9scjvqd">Turid Rugaas</strong>, wereldberoemde Noorse
              hondentrainster, auteur en expert in hondentaal
            </p>
            <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-4241" data-mp="37icyl9tl3lce">
              DISCLAIMER: Dit is geen aanbeveling van Turid Rugaas
            </p>
          </div>
          <div className="w-48 h-48 flex-shrink-0" data-id="element-4242" data-mp="3gjjf3iw8gw5n">
            <img src="https://cdn.magicpatterns.com/uploads/5u3DrMLHNnG7KPDoQAwX5E/e34559c94a8bf7103f4c6cb20d81f245.jpg" alt="Turid Rugaas" className="w-full h-full object-cover rounded-xl shadow-lg grayscale" data-id="element-4243" data-mp="3gkcd9vh4mdc6" />
          </div>
        </div>
      </section>

      {/* 25. FAQ */}
      <section className="bg-[#faf5eb] py-16" data-id="element-4244" data-mp="3vajwideyk0dx">
        <div className="max-w-5xl mx-auto px-4" data-id="element-4245" data-mp="34wn1h66e3r2">
          <h2 className="text-4xl font-black text-[#1a2b4a] text-center mb-16" data-id="element-4246" data-mp="36r94yt6o1wq">
            Veelgestelde vragen
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-4247" data-mp="d2kpyudxqhkb">
            {[{
            q: 'Ik wil dit, wat krijg ik exact?',
            a: 'Na je aankoop ontvang je een email met een inlogcode tot ons leerplatform. In dit platform vindt je drie uitgebreide lessen waarin je alles leert over de verlatingsangst kernaanpak.'
          }, {
            q: 'Wat is de Verlatingsangst Kernaanpak?',
            a: 'Dit is een nieuwe methode waarin je het onderliggende kernprobleem van verlatingsangst aanpakt in plaats van je alleen maar te richten op oefenen. Wij gebruiken deze methode om jaarlijks bij honderden honden verlatingsangst bij de kern aan te pakken en op te lossen.'
          }, {
            q: 'Kan ik meer hulp krijgen als ik dit wil?',
            a: 'Ja, er is een knop om in contact te komen met iemand van ons team die je meer kan uitleggen over onze 1-op-1 hulp.'
          }, {
            q: 'Wat maakt dit anders dan alle andere informatie online?',
            a: "Alles wat je kan vinden gaat alleen maar over oefen schema's en verschillende methodes van oefenen. Met deze methode kijk je naar het type verlatingsangst dat je hond heeft, pak je dat bij de kern aan en ga je daarna pas oefenen. Op deze manier heb je sneller, beter en blijvend resultaat."
          }, {
            q: 'Voor wie is dit?',
            a: 'Dit is voor hondenbaasjes die de verlatingsangst van hun hond nu voor eens en altijd willen oplossen en dit op een empatische manier willen doen.'
          }, {
            q: 'Is er een garantie?',
            a: 'Ja, je krijgt een 365 dagen niet-goed, geld-terug garantie voor het geval je toch niet tevreden bent.'
          }].map((faq, i) => <div key={i} data-id="element-4248" data-mp="10y76no8bh0lc" data-mpi={i}>
                <h4 className="font-bold text-xl text-[#1a2b4a] mb-3 flex items-start gap-3" data-id="element-4249" data-mp="10xxrkvot8duf">
                  <HelpCircle className="w-6 h-6 text-[#5ce0d2] flex-shrink-0 mt-0.5" data-id="element-4250" data-mp="15xtns8r9n0zf" />
                  {faq.q}
                </h4>
                <p className="text-[#5ce0d2] pl-9 leading-relaxed" data-id="element-4251" data-mp="3gi23gmphla7">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 26. FINAL CTA */}
      <div className="bg-[#ffb800] py-12 text-center px-4" data-id="element-4252" data-mp="cirde8pstion">
        <div className="max-w-md mx-auto" data-id="element-4253" data-mp="hgsx8vv1tm16">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak-g" className="block w-full bg-transparent border-4 border-[#1a2b4a] text-[#1a2b4a] hover:bg-[#1a2b4a] hover:text-white font-black py-4 px-4 rounded-lg text-2xl transition-colors" data-id="element-4254" data-mp="hfhsotts4a90">
            Start met deze methode
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-4255" data-mp="3un2ogn1tg50w">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 27. FOOTER */}
      <footer className="bg-[#111827] text-gray-400 py-12 text-xs leading-relaxed text-center px-4" data-id="element-4256" data-mp="2x64ao9onow4t">
        <div className="max-w-5xl mx-auto space-y-6" data-id="element-4257" data-mp="324oz7bujprdf">
          <p className="font-bold text-white mb-8" data-id="element-4258" data-mp="2umhamesuxtja">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-y border-gray-800 py-8 mb-8" data-id="element-4259" data-mp="2fqrpeivhxkfm">
            <p className="font-bold text-white" data-id="element-4260" data-mp="2bpg76yeyc1hg">
              Copywriting van Stressless Dogs Nederland BV
            </p>
            <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak-g" className="bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-8 rounded-lg text-lg transition-colors" data-id="element-4261" data-mp="26wn3mdv7yz6y">
              Start met de training.
            </a>
          </div>

          <p className="text-justify" data-id="element-4262" data-mp="1s2iam0wp9wxz">
            We can not and do not make any guarantees about your ability to get
            results or earn any money with our ideas, information, tools, or
            strategies. What we can guarantee is your satisfaction with our
            training. We give you a 30-day 100% satisfaction guarantee on the
            products we sell, so if you are not happy for any reason with the
            quality of our training, just ask for your money back. You should
            know that all products and services by our company are for
            educational and informational purposes only. Nothing on this page,
            any of our websites, or any of our content or curriculum is a
            promise or guarantee of results or future earnings, and we do not
            offer any legal, medical, tax or other professional advice. Any
            financial numbers referenced here, or on any of our sites, are
            illustrative of concepts only and should not be considered average
            earnings, exact earnings, or promises for actual or future
            performance. Use caution and always consult your accountant, lawyer
            or professional advisor before acting on this or any information
            related to a lifestyle change or your business or finances. You
            alone are responsible and accountable for your decisions, actions
            and results in life, and by your registration here you agree not to
            attempt to hold us liable for your decisions, actions or results, at
            any time, under any circumstance.
          </p>
        </div>
      </footer>

      {/* 23. STICKY BOTTOM BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#1a2b4a] border-t-4 border-[#5ce0d2] p-3 flex items-center justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-4263" data-mp="2l5nv1j3v8zy2">
        <div className="flex items-center justify-between md:justify-center gap-3 md:gap-8 w-full max-w-5xl" data-id="element-4264" data-mp="2g8nnt4va5r5d">
          <div className="flex items-center gap-3 md:gap-6" data-id="element-4265" data-mp="h9j73osahvf">
            <img src="https://cdn.magicpatterns.com/uploads/oxTbd4Fk83NKokLatjZK4s/Verlatingangst_kernmethode_bonus_(4).png" alt="Verlatingsangst Kernaanpak Boek" className="hidden md:block w-16 h-auto object-contain" data-id="element-4266" data-mp="3rky80mvykey7" />
            <img src="https://cdn.magicpatterns.com/uploads/cRmnco8rsPRXFAp45VMFKA/Ontwerp_zonder_titel_(70).png" alt="Verlatingsangst Kernaanpak" className="w-16 md:w-24 h-auto object-contain" data-id="element-4267" data-mp="2b2k5qkv9smze" />
            <div data-id="element-4268" data-mp="2k1dz82db0x8q">
              <div className="text-white font-bold text-sm md:text-base leading-tight" data-id="element-4269" data-mp="2p2l7e2jczyfx">
                Verlatingsangst Kernaanpak
              </div>
              <div className="text-[#5ce0d2] font-black text-lg md:text-xl" data-id="element-4270" data-mp="2tumd15m0uqwz">
                <span className="text-red-500 line-through decoration-[3px] mr-2" data-id="element-4271" data-mp="2ysnwhrnd0s8z">
                  €97
                </span>
                €27
              </div>
            </div>
          </div>
          <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak-g" className="bg-[#ffb800] text-[#1a2b4a] font-bold py-2 px-6 md:px-8 md:py-3 rounded-lg text-sm md:text-base shadow-md whitespace-nowrap" data-id="element-4272" data-mp="37sb10mbdye69">
            Naar Stap #2
          </a>
        </div>
      </div>
    </div>;
}